function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ApolloProvider, useApolloClient } from "@apollo/client";
import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { DarkTheme, DefaultTheme, getActionFromState, getPathFromState, getStateFromPath, NavigationContainer } from "@react-navigation/native";
import setDefaultOptions from "date-fns/setDefaultOptions";
import { applicationId } from "expo-application";
import * as Localization from "expo-localization";
import * as Notifications from "expo-notifications";
import * as SplashScreen from "expo-splash-screen";
import { produce } from "immer";
import { stringify } from "querystringify";
import { Component, forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { AppState, Platform, Linking as RNLinking } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { KeyboardProvider } from "react-native-keyboard-controller";
import { Menu, MenuProvider, renderers } from "react-native-popup-menu";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { getIntlFirstWeekdayAsDateDay } from "@oui/lib/src/getIntlFirstWeekday";
import { clearFrescoMemoryCache } from "@oui/native-utils";
import { Reauthenticate } from "./Reauthenticate";
import { AccessibilityProvider } from "./AccessibilityContext";
import AppContext from "./AppContext";
import { AppError } from "./AppError";
import { Button } from "./Button";
import { CurrentUserProvider } from "./CurrentUserContext";
import { DevMenu } from "./DevMenu";
import { Icon } from "./Icon";
import { InternetConnectivityProvider } from "./InternetConnectivityProvider";
import { MinimumAppVersion } from "./MinimumAppVersion";
import { OrientationProvider } from "./OrientationContext";
import { SnackbarProvider } from "./SnackbarProvider";
import { Text } from "./Text";
import { View } from "./View";
import { APP_SLUG, manifest } from "../constants";
import { useAppState } from "../hooks/useAppState";
import { CurrentUserQuery } from "../hooks/useCurrentUser";
import { useDetoxSideEffects } from "../hooks/useDetoxSideEffects";
import { LogoutProvider } from "../hooks/useLogout";
import { authClient } from "../lib/auth";
import { checkForUpdateAsync } from "../lib/checkForUpdateAsync";
import { I18nProvider } from "../lib/i18n";
import { initApp, shouldShowWebBlocker } from "../lib/initApp";
import { addBreadcrumb } from "../lib/log";
import LogBox from "../lib/LogBox";
import { parseUrl } from "../lib/parseUrl";
import { PermissionsManagerProvider } from "../lib/permissionsManager";
import { resumableUploadManager } from "../lib/resumableUploadManager";
import { setDeviceInfo } from "../lib/setDeviceInfo";
import Sentry, { routingInstrumentation } from "../sentry";
import { Shadow, useTheme } from "../styles";
var LATEST_NAVIGATION_STATE_KEY = "".concat(APP_SLUG, ":lastNavigationState");
Menu.setDefaultRenderer(renderers.Popover);
Menu.setDefaultRendererProps({
    placement: 'bottom',
    anchorStyle: [
        Shadow.default
    ]
});
DefaultTheme.colors.background = 'white';
LogBox.ignoreLogs([
    'Accessing view manager configs',
    'componentWillMount',
    'componentWillReceiveProps',
    '[react-native-gesture-handler] Seems'
]);
function useLowMemoryWarning() {
    useEffect(function() {
        if (Platform.OS === 'web') return;
        var onMemoryWarningListener = AppState.addEventListener('memoryWarning', function(data) {
            addBreadcrumb({
                category: 'app-state-memory',
                data: {
                    data: data
                },
                level: 'debug'
            });
            clearFrescoMemoryCache();
        });
        return function() {
            onMemoryWarningListener === null || onMemoryWarningListener === void 0 ? void 0 : onMemoryWarningListener.remove();
        };
    }, []);
}
/**
 * Ensures we always have a route to navigate back to if opening app from a deeplink / notification
 */ function ensureInitialRoute(defaultState, targetState) {
    // If we don't have a default state in this app, then abort
    if (!defaultState) return targetState;
    // If targetState is already linking to the same screen as the defaultState, then just use targetState
    if (defaultState.routes[0].name === targetState.routes[0].name) return targetState;
    return _object_spread_props(_object_spread({}, targetState), {
        index: defaultState.routes.length,
        routes: _to_consumable_array(defaultState.routes).concat(_to_consumable_array(targetState.routes))
    });
}
var AppContainerInner = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _useState = _sliced_to_array(useState(), 2), initialNavigationState = _useState[0], setInitialNavigationState = _useState[1];
    var flags = useContext(AppContext).flags;
    var scheme = useTheme().scheme;
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), loading = _useState2[0], setLoading = _useState2[1];
    var navigator = useRef(undefined);
    var _useState3 = _sliced_to_array(useState(null), 2), navigatorState = _useState3[0], setNavigatorState = _useState3[1];
    var handleNotificationRef = useRef(undefined);
    var Main = props.app;
    var deeplinkConfigRef = useRef(props.deeplinkConfig);
    var latestStateRef = useRef(undefined);
    var apollo = useApolloClient();
    var initialPath = props.initialPath;
    var _useState4 = _sliced_to_array(useState({
        callback: undefined
    }), 2), reauthenticateCallback = _useState4[0], setReauthenticateCallback = _useState4[1];
    navigator.current = navigatorState !== null && navigatorState !== void 0 ? navigatorState : undefined;
    useImperativeHandle(ref, function() {
        return navigatorState;
    }, [
        navigatorState
    ]);
    var handleNotification = useCallback(function(notification) {
        var skipLoadingCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, defaultState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
        // console.log({
        //   notification: JSON.stringify(notification, null, 2),
        //   skipLoadingCheck,
        //   navigator: !!navigator.current,
        //   loading,
        // });
        if (!skipLoadingCheck && loading) {
            return false;
        }
        addBreadcrumb({
            category: 'notification',
            data: notification
        });
        // Ignore fake notification present in latest SDK version
        // https://github.com/expo/expo/issues/28656#issuecomment-2198200751
        if (notification.notification.date === 0 && notification.notification.request.identifier === null) {
            return false;
        }
        Notifications.dismissNotificationAsync(notification.notification.request.identifier).catch(Sentry.captureException);
        var content = notification.notification.request.content;
        var trigger = notification.notification.request.trigger;
        var _content_data;
        var data = (_content_data = content.data) !== null && _content_data !== void 0 ? _content_data : trigger && 'payload' in trigger ? trigger.payload : undefined;
        if ((data === null || data === void 0 ? void 0 : data.type) === 'navigate') {
            var path;
            if ('path' in data.payload) {
                path = data.payload.path;
            } else {
                var _data_payload_name;
                var payload = {
                    name: (_data_payload_name = data.payload.name) !== null && _data_payload_name !== void 0 ? _data_payload_name : data.payload.routeName,
                    params: data.payload.params
                };
                var paramsStr = payload.params ? stringify(payload.params) : '';
                path = "".concat(payload.name).concat(paramsStr ? "?".concat(paramsStr) : '');
            }
            var state = getStateFromPath(path, deeplinkConfigRef.current);
            if (navigator.current) {
                var _navigator_current;
                (_navigator_current = navigator.current) === null || _navigator_current === void 0 ? void 0 : _navigator_current.dispatch(getActionFromState(state));
            } else {
                setInitialNavigationState(ensureInitialRoute(defaultState, state));
            }
            return true;
        }
        return false;
    }, [
        loading
    ]);
    handleNotificationRef.current = handleNotification;
    useAppState(function(status) {
        addBreadcrumb({
            category: 'app-state',
            data: {
                status: status
            },
            level: 'debug'
        });
    });
    useAppState(function(status) {
        if (status === 'active') {
            var locale = Localization.getLocales()[0].languageTag;
            setDefaultOptions({
                weekStartsOn: getIntlFirstWeekdayAsDateDay(locale)
            });
        }
    });
    useEffect(function() {
        resumableUploadManager.startPendingUploads().catch(function(e) {
            return Sentry.captureException(e);
        });
    }, []);
    var forceOffline = useDetoxSideEffects().forceOffline;
    useLowMemoryWarning();
    useEffect(function() {
        if (Platform.OS === 'web') return;
        var handleOpenURL = function(param) {
            var url = param.url;
            var parsedUrl = parseUrl(url);
            var initialURLState = (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.path) ? getStateFromPath(parsedUrl.pathWithQuery, deeplinkConfigRef.current) : undefined;
            addBreadcrumb({
                category: 'navigation',
                message: 'handleOpenURL',
                data: {
                    url: url,
                    parsedUrl: parsedUrl,
                    initialURLState: initialURLState
                }
            });
        };
        var handleNotificationSubscription = Notifications.addNotificationResponseReceivedListener(handleNotification);
        Notifications.setNotificationHandler({
            handleNotification: /*#__PURE__*/ _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        {
                            // Detox requires the legacy alert presentation option before it will simulate
                            // tapping a notification while the app is already in the foreground.
                            shouldShowAlert: !!global.e2e,
                            shouldShowBanner: true,
                            shouldShowList: true,
                            shouldPlaySound: false,
                            shouldSetBadge: false
                        }
                    ];
                });
            })
        });
        var urlSubscription = RNLinking.addEventListener('url', handleOpenURL);
        return function() {
            urlSubscription.remove();
            if (handleNotificationSubscription) {
                handleNotificationSubscription.remove();
            }
            Notifications.setNotificationHandler(null);
        };
    }, [
        handleNotification
    ]);
    var init = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var initialURL, reauthenticate, parsedUrl, initialURLState, primaryNavigation, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        6,
                        7,
                        8
                    ]);
                    return [
                        4,
                        RNLinking.getInitialURL()
                    ];
                case 1:
                    initialURL = _state.sent();
                    return [
                        4,
                        initApp(apollo)
                    ];
                case 2:
                    reauthenticate = _state.sent().reauthenticate;
                    parsedUrl = parseUrl(initialURL);
                    initialURLState = !process.env.STORYBOOK_CLIENT && (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.path) ? getStateFromPath(parsedUrl.pathWithQuery, deeplinkConfigRef.current) : undefined;
                    Sentry.addBreadcrumb({
                        message: 'init',
                        data: {
                            reauthenticate: reauthenticate,
                            initialURLState: initialURLState,
                            parsedUrl: parsedUrl,
                            initialURL: initialURL
                        }
                    });
                    primaryNavigation = /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function() {
                            var isLoggedIn, productUser, r, e, defaultState, handled, initialNotification, getPrimaryNavigationState;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isLoggedIn = authClient.getIsLoggedIn();
                                        productUser = null;
                                        if (!isLoggedIn) return [
                                            3,
                                            7
                                        ];
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            5,
                                            ,
                                            6
                                        ]);
                                        return [
                                            4,
                                            apollo.query({
                                                query: CurrentUserQuery,
                                                fetchPolicy: 'cache-first'
                                            })
                                        ];
                                    case 2:
                                        r = _state.sent();
                                        productUser = r.data.user;
                                        if (!!productUser) return [
                                            3,
                                            4
                                        ];
                                        Sentry.captureMessage('No productUser found for logged in user');
                                        return [
                                            4,
                                            authClient.signOut()
                                        ];
                                    case 3:
                                        _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            3,
                                            6
                                        ];
                                    case 5:
                                        e = _state.sent();
                                        Sentry.captureException(e, function(scope) {
                                            scope.setExtras({
                                                location: 'preload productUser'
                                            });
                                            return scope;
                                        });
                                        return [
                                            3,
                                            6
                                        ];
                                    case 6:
                                        void setDeviceInfo(apollo);
                                        _state.label = 7;
                                    case 7:
                                        defaultState = getStateFromPath(typeof initialPath === 'function' ? initialPath({
                                            user: productUser
                                        }) : initialPath, deeplinkConfigRef.current);
                                        // react-navigation handles the initial url on web by default so if we're planning to
                                        // set initial state to the initial url ourselves, just mark the action as already handled
                                        // https://reactnavigation.org/docs/navigation-container/#initialstate
                                        handled = false;
                                        if (!(Platform.OS === 'web' && (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.isDeeplink))) return [
                                            3,
                                            8
                                        ];
                                        handled = true;
                                        return [
                                            3,
                                            10
                                        ];
                                    case 8:
                                        if (!(Platform.OS !== 'web')) return [
                                            3,
                                            10
                                        ];
                                        return [
                                            4,
                                            Notifications.getLastNotificationResponseAsync()
                                        ];
                                    case 9:
                                        initialNotification = _state.sent();
                                        if (initialNotification) {
                                            handled = handled || handleNotificationRef.current(initialNotification, true, defaultState);
                                        }
                                        _state.label = 10;
                                    case 10:
                                        if (!!handled) return [
                                            3,
                                            12
                                        ];
                                        getPrimaryNavigationState = /*#__PURE__*/ function() {
                                            var _ref = _async_to_generator(function() {
                                                var persistedStateStr, persistedState;
                                                return _ts_generator(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                AsyncStorage.getItem(LATEST_NAVIGATION_STATE_KEY)
                                                            ];
                                                        case 1:
                                                            persistedStateStr = _state.sent();
                                                            if (persistedStateStr) {
                                                                AsyncStorage.removeItem(LATEST_NAVIGATION_STATE_KEY).catch(Sentry.captureException);
                                                                persistedState = JSON.parse(persistedStateStr);
                                                                return [
                                                                    2,
                                                                    persistedState
                                                                ];
                                                            } else if (initialURLState) {
                                                                return [
                                                                    2,
                                                                    ensureInitialRoute(defaultState, initialURLState)
                                                                ];
                                                            } else if (isLoggedIn && shouldShowWebBlocker()) {
                                                                return [
                                                                    2,
                                                                    getStateFromPath('WebBlocker', deeplinkConfigRef.current)
                                                                ];
                                                            }
                                                            return [
                                                                2,
                                                                defaultState
                                                            ];
                                                    }
                                                });
                                            });
                                            return function getPrimaryNavigationState() {
                                                return _ref.apply(this, arguments);
                                            };
                                        }();
                                        return [
                                            4,
                                            getPrimaryNavigationState()
                                        ];
                                    case 11:
                                        setInitialNavigationState.apply(void 0, [
                                            _state.sent()
                                        ]);
                                        _state.label = 12;
                                    case 12:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function primaryNavigation() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (!reauthenticate) return [
                        3,
                        3
                    ];
                    setReauthenticateCallback({
                        callback: primaryNavigation
                    });
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        primaryNavigation()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    setLoading(false);
                    setError(false);
                    return [
                        3,
                        8
                    ];
                case 6:
                    e = _state.sent();
                    console.error(e);
                    Sentry.captureException(e);
                    setError(true);
                    return [
                        3,
                        8
                    ];
                case 7:
                    if (Platform.OS !== 'web') {
                        SplashScreen.hideAsync().catch(Sentry.captureException);
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        initialPath,
        apollo
    ]);
    useEffect(function() {
        init().catch(Sentry.captureException);
    }, [
        init
    ]);
    return reauthenticateCallback.callback ? /*#__PURE__*/ _jsx(Reauthenticate, {
        onSuccess: /*#__PURE__*/ _async_to_generator(function() {
            var _reauthenticateCallback_callback;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_reauthenticateCallback_callback = reauthenticateCallback.callback) === null || _reauthenticateCallback_callback === void 0 ? void 0 : _reauthenticateCallback_callback.call(reauthenticateCallback)
                        ];
                    case 1:
                        _state.sent();
                        setReauthenticateCallback({
                            callback: undefined
                        });
                        return [
                            2
                        ];
                }
            });
        }),
        onLogout: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(forgotPassword) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            setReauthenticateCallback({
                                callback: undefined
                            });
                            return [
                                4,
                                init()
                            ];
                        case 1:
                            _state.sent();
                            if (forgotPassword) {
                                setTimeout(function() {
                                    var // @ts-expect-error
                                    _navigator_current;
                                    (_navigator_current = navigator.current) === null || _navigator_current === void 0 ? void 0 : _navigator_current.navigate('RequestResetPassword', {});
                                }, 100);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(forgotPassword) {
                return _ref.apply(this, arguments);
            };
        }()
    }) : error ? /*#__PURE__*/ _jsx(AppError, {
        retry: init
    }) : loading ? null : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SystemBars, {
                style: flags.allowDarkTheme && scheme === 'dark' ? 'light' : 'dark'
            }),
            /*#__PURE__*/ _jsx(PermissionsManagerProvider, {
                onOpenSettings: function() {
                    if (!latestStateRef.current) return Promise.resolve();
                    return AsyncStorage.setItem(LATEST_NAVIGATION_STATE_KEY, JSON.stringify(latestStateRef.current));
                },
                onCloseSettings: function() {
                    return AsyncStorage.removeItem(LATEST_NAVIGATION_STATE_KEY);
                },
                children: /*#__PURE__*/ _jsx(InternetConnectivityProvider, {
                    forceOffline: forceOffline,
                    onReconnect: function() {
                        resumableUploadManager.startPendingUploads().catch(function(e) {
                            return Sentry.captureException(e);
                        });
                    },
                    children: /*#__PURE__*/ _jsx(MinimumAppVersion, {
                        children: /*#__PURE__*/ _jsx(SnackbarProvider, {
                            children: /*#__PURE__*/ _jsx(NavigationContainer, {
                                linking: {
                                    prefixes: [
                                        "".concat(manifest.scheme, "://"),
                                        "".concat(applicationId || 'com.ouitherapeutics.app', "://"),
                                        'https://oui.health',
                                        'https://oui.dev',
                                        'https://*.oui.dev',
                                        'https://*.oui.health'
                                    ],
                                    config: deeplinkConfigRef.current
                                },
                                documentTitle: {
                                    // we disable document title handling for two reasons
                                    // 1) it messes up screen capture in detox-puppeteer (b/c we select the video source by doc title)
                                    // 2) we need to create a better custom formatter and it's not immediately obvious what the logic is
                                    enabled: false
                                },
                                initialState: initialNavigationState,
                                theme: flags.allowDarkTheme && scheme === 'dark' ? DarkTheme : DefaultTheme,
                                onReady: function() {
                                    // eslint-disable-next-line
                                    routingInstrumentation.registerNavigationContainer(navigator);
                                },
                                onStateChange: function(state) {
                                    var _navigator_current;
                                    latestStateRef.current = state;
                                    // console.log('onStateChange', state);
                                    // if (state) console.log(getPathFromState(state, deeplinkConfigRef.current));
                                    if (!state) return;
                                    var currentRoute = (_navigator_current = navigator.current) === null || _navigator_current === void 0 ? void 0 : _navigator_current.getCurrentRoute();
                                    var breadcrumbState = produce(state, function(draft) {
                                        draft.routeNames = []; // don't need this list for debugging purposes
                                    });
                                    addBreadcrumb({
                                        category: 'navigation',
                                        data: {
                                            state: breadcrumbState,
                                            path: getPathFromState(state, deeplinkConfigRef.current),
                                            name: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.name,
                                            params: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.params
                                        },
                                        level: 'debug'
                                    });
                                },
                                ref: function(r) {
                                    setNavigatorState(r);
                                },
                                onUnhandledAction: function(e) {
                                    Sentry.captureException('Navigation not handled', {
                                        extra: e
                                    });
                                },
                                children: /*#__PURE__*/ _jsx(Main, {})
                            })
                        })
                    })
                })
            })
        ]
    });
});
function WebUpdateAvailableToast(param) {
    var onDismiss = param.onDismiss;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsxs(View, {
        style: [
            {
                position: 'absolute',
                bottom: 20,
                right: 20,
                width: 300,
                padding: 20,
                borderRadius: 20,
                backgroundColor: theme.color.gray800
            },
            Shadow.default
        ],
        spacing: 10,
        children: [
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: "Update available",
                        weight: "semibold"
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        "aria-label": "Dismiss",
                        name: "close",
                        size: 14,
                        onPress: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                text: "A new version of the website is available. Please refresh to get the latest features and improvements.",
                size: 13
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "text",
                text: "Update",
                alignSelf: "flex-end",
                size: "small",
                onPress: function() {
                    global.window.location.reload();
                }
            })
        ]
    });
}
/**
 * Root container component for rendering an app. Is responsible for managing
 * various initialization tasks and event listeners for the lifetime of the
 * app.
 *
 * - General app initialization
 * - Mounts various internal and third-party react providers
 * - API/apollo client
 * - Initial & ongoing URL / deeplinks
 * - Reauthentication
 * - Notifications
 * - App / system state changes
 *
 * App-specific content/messages/deeplink configuration should be passed in via
 * props to customize the container for use in a specific app.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-50}
 */ export var AppContainer = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AppContainer, Component);
    function AppContainer() {
        _class_call_check(this, AppContainer);
        var _this;
        _this = _call_super(this, AppContainer, arguments), _define_property(_this, "state", {
            hasError: false,
            updateAvailable: false,
            navigator: null
        }), _define_property(_this, "lastUpdateCheckAt", Date.now()), _define_property(_this, "dispatch", function(action) {
            var navigator = _this.state.navigator;
            navigator === null || navigator === void 0 ? void 0 : navigator.dispatch(action);
        });
        return _this;
    }
    _create_class(AppContainer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (Platform.OS === 'web' && APP_SLUG !== 'oui-aviva') {
                    AppState.addEventListener('change', function(nextStatus) {
                        if (nextStatus === 'active' && Date.now() - _this.lastUpdateCheckAt > 60 * 60 * 1000) {
                            _this.lastUpdateCheckAt = Date.now();
                            void checkForUpdateAsync().then(function(param) {
                                var isAvailable = param.isAvailable;
                                if (isAvailable) {
                                    _this.setState({
                                        updateAvailable: true
                                    });
                                }
                            });
                        }
                    });
                }
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(e, info) {
                Sentry.withScope(function(scope) {
                    scope.setExtra('info', info);
                    Sentry.captureException(e);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ _jsx(View, {
                    testID: "AppContainer",
                    style: {
                        flex: 1
                    },
                    children: /*#__PURE__*/ _jsx(AppContext.Provider, {
                        value: {
                            navigationContainer: this.state.navigator,
                            flags: this.props.flags,
                            locale: Localization.getLocales()[0].languageTag,
                            deeplinkConfig: this.props.deeplinkConfig,
                            Logo: this.props.Logo,
                            onboardingGraphic: this.props.onboardingGraphic
                        },
                        children: /*#__PURE__*/ _jsx(GestureHandlerRootView, {
                            children: /*#__PURE__*/ _jsx(AccessibilityProvider, {
                                children: /*#__PURE__*/ _jsx(KeyboardProvider, {
                                    children: /*#__PURE__*/ _jsx(SafeAreaProvider, {
                                        children: /*#__PURE__*/ _jsx(ActionSheetProvider, {
                                            children: /*#__PURE__*/ _jsx(ApolloProvider, {
                                                client: this.props.apollo,
                                                children: /*#__PURE__*/ _jsx(OrientationProvider, {
                                                    children: /*#__PURE__*/ _jsx(LogoutProvider, {
                                                        children: /*#__PURE__*/ _jsx(CurrentUserProvider, {
                                                            children: /*#__PURE__*/ _jsx(MenuProvider, {
                                                                children: /*#__PURE__*/ _jsx(I18nProvider, {
                                                                    getMessages: this.props.getMessages,
                                                                    children: /*#__PURE__*/ _jsxs(DevMenu, {
                                                                        onNavigate: this.dispatch,
                                                                        children: [
                                                                            this.state.hasError ? /*#__PURE__*/ _jsx(AppError, {
                                                                                retry: function() {
                                                                                    return _this.setState({
                                                                                        hasError: false
                                                                                    });
                                                                                },
                                                                                type: "runtime"
                                                                            }) : /*#__PURE__*/ _jsx(AppContainerInner, {
                                                                                app: this.props.app,
                                                                                ref: function(r) {
                                                                                    if (!_this.state.navigator && r) {
                                                                                        _this.setState({
                                                                                            navigator: r
                                                                                        });
                                                                                    }
                                                                                },
                                                                                initialPath: this.props.initialPath,
                                                                                deeplinkConfig: this.props.deeplinkConfig
                                                                            }),
                                                                            this.state.updateAvailable ? /*#__PURE__*/ _jsx(WebUpdateAvailableToast, {
                                                                                onDismiss: function() {
                                                                                    return _this.setState({
                                                                                        updateAvailable: false
                                                                                    });
                                                                                }
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    navigator: null,
                    hasError: true
                };
            }
        }
    ]);
    return AppContainer;
}(Component);
